// Was am Beschaffungsweg feststeht, unabhängig davon, wo er erfasst wird.
//
// Seit A4 gibt es zwei Orte, an denen ein Weg entsteht: die Detailansicht
// (Nachtrag) und das Erfassungsformular (schon beim Anlegen). Zwei Kopien
// dieser Listen liefen früher oder später auseinander — und dann hieße
// derselbe Kanal an einer Stelle „Bonus-Mail" und an der anderen gar
// nicht mehr.

/** Der Code des Verlags-Wegs. Das Label pflegt der Admin, der Code nicht. */
export const WEG_VERLAG = 'verlag';

/**
 * Die Kanäle beim Verlag. „Sonstiges" ist kein Kanal, sondern der
 * Hinweis, dass der Nutzer selbst schreibt — sein Text landet dann als
 * Kanal in der Datenbank (siehe Migration 018).
 */
export const KANAELE: readonly [string, string][] = [
  ['bonus', 'Bonus'],
  ['bonus_mail', 'Bonus-Mail'],
  ['webshop', 'Verlags-Webshop']
];

export const KANAL_SONSTIGES = '__sonstiges__';

/**
 * Die Wege, die am haeufigsten gebraucht werden — als Schnellwege an
 * der Position (A12.2; `verlag` seit D3 dabei).
 *
 * NUR DIE CODES STEHEN HIER, NICHT DIE BESCHRIFTUNGEN. Die pflegt der
 * Admin in `beschaffungswege` (Designprinzip 2). Was hier steht, ist die
 * Auswahl und ihre Reihenfolge, nicht der Text.
 *
 * Fehlt einer in der Tabelle — weil er stillgelegt oder umbenannt
 * wurde —, faellt sein Knopf weg und die uebrigen bleiben. Ein Knopf,
 * dessen Weg es nicht gibt, wuerde beim Antippen einen Fehler vom
 * Server holen; besser gar nicht erst da.
 *
 * `lager` steht bewusst zuerst: Es ist der einzige, der KEINE
 * Bestellung ist (E4), und der Fall, in dem man am haeufigsten gar nichts
 * weiter tun muss.
 *
 * `verlag` OHNE Kanal und Verlagsname (D3, Entscheidung des Betreibers):
 * Beide Angaben sind freiwillig, und dass der Schnellweg sie nicht
 * erfasst, ist ausdruecklich in Ordnung. Bis D3 galt das Gegenteil
 * („braucht zwei weitere Angaben, taugt nicht als Schnellweg") — der
 * Betrieb hat es anders entschieden: der haeufige Griff ist „beim Verlag
 * bestellt", nicht das Ausfuellen zweier Felder. Wer Kanal oder Namen
 * festhalten will, nimmt weiterhin das Formular.
 */
export const SCHNELLWEGE: readonly string[] = ['lager', 'libri', 'umbreit', 'verlag'];

/** Der Weg, der keine Bestellung ist (E4). */
export const WEG_LAGER = 'lager';
